import { Icons } from '../../Icons';

const TableActionCloseButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <span
      role="button"
      tabIndex={0}
      className="size-5 rounded-xs p-xxs flex items-center justify-center gap-md bg-transparent hover:bg-bg-brand-hover transition-all duration-200 text-fg-brand hover:text-fg-brand-hover"
      onPointerDownCapture={(e) => {
        // Prevent Radix Dropdown trigger from handling pointer down
        e.stopPropagation();
        e.preventDefault();
      }}
      onMouseDown={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
      onKeyDownCapture={(e) => {
        // Prevent Space/Enter from triggering the Radix trigger
        if (e.key === ' ' || e.key === 'Enter') {
          e.stopPropagation();
          e.preventDefault();
          onClick();
        }
      }}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        onClick();
      }}
      aria-label="Close"
    >
      <Icons.XClose className="size-5" />
    </span>
  );
};

export { TableActionCloseButton };
